// DEPRECATED: Vuex store has been migrated to Pinia
// This file is kept as a stub for backwards compatibility with stale imports
// All state management now uses Pinia stores in src/stores/
// TODO: Remove this file and clean up all `import store from '@/store'` statements

export default {};
